import React from 'react';
import { BriefcaseBusiness, Building2, ContactRound, FileText, Phone, UserRound } from 'lucide-react';
import { EMPLOYMENT_TYPE_LABELS } from '../../utils/accountLabels';
import PersonnelCompensationFields from './PersonnelCompensationFields';

const PersonnelFormFields = ({ formData, setFormData, showStatus = true, showNotes = true, showCode = true }) => {
  const updateField = (field) => (event) => {
    setFormData((current) => ({ ...current, [field]: event.target.value }));
  };

  return (
    <div className="space-y-6">
      <section className="rounded-[2rem] border border-slate-100 bg-white p-6 shadow-sm">
        <div className="mb-5 flex items-center gap-2">
          <UserRound size={18} className="text-blue-600" />
          <div>
            <h3 className="text-base font-black text-slate-800">Kişisel Bilgiler</h3>
            <p className="text-xs font-medium text-slate-400">Temel personel bilgilerini ve iletişim bilgilerini girin.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <label className="block md:col-span-2">
            <span className="mb-2 ml-1 block text-[10px] font-black uppercase tracking-widest text-slate-400">Ad Soyad</span>
            <input
              required
              value={formData.name || ''}
              onChange={updateField('name')}
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none transition-all focus:border-blue-500 focus:bg-white"
              placeholder="Personel adı"
            />
          </label>

          {showCode && (
            <label className="block">
              <span className="mb-2 ml-1 block text-[10px] font-black uppercase tracking-widest text-slate-400">Kod</span>
              <input
                required
                value={formData.code || ''}
                onChange={updateField('code')}
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none transition-all focus:border-blue-500 focus:bg-white"
                placeholder="Personel kodu"
              />
            </label>
          )}

          {showStatus && (
            <label className="block">
              <span className="mb-2 ml-1 block text-[10px] font-black uppercase tracking-widest text-slate-400">Durum</span>
              <select
                value={formData.status || 'Active'}
                onChange={updateField('status')}
                className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none transition-all focus:border-blue-500 focus:bg-white"
              >
                <option value="Active">Aktif</option>
                <option value="Passive">Pasif</option>
              </select>
            </label>
          )}

          <label className="block">
            <span className="mb-2 ml-1 flex items-center gap-1 text-[10px] font-black uppercase tracking-widest text-slate-400">
              <Phone size={12} />
              Telefon
            </span>
            <input
              value={formData.phone || ''}
              onChange={updateField('phone')}
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none transition-all focus:border-blue-500 focus:bg-white"
              placeholder="+90 5xx xxx xx xx"
            />
          </label>

          <label className="block">
            <span className="mb-2 ml-1 flex items-center gap-1 text-[10px] font-black uppercase tracking-widest text-slate-400">
              <ContactRound size={12} />
              E-posta
            </span>
            <input
              type="email"
              value={formData.email || ''}
              onChange={updateField('email')}
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none transition-all focus:border-blue-500 focus:bg-white"
              placeholder="personel@firma.com"
            />
          </label>
        </div>
      </section>

      <section className="rounded-[2rem] border border-slate-100 bg-white p-6 shadow-sm">
        <div className="mb-5 flex items-center gap-2">
          <BriefcaseBusiness size={18} className="text-violet-600" />
          <div>
            <h3 className="text-base font-black text-slate-800">Çalışma Bilgileri</h3>
            <p className="text-xs font-medium text-slate-400">Çalışma tipi ve ödeme bilgilerini girin.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <label className="block">
            <span className="mb-2 ml-1 flex items-center gap-1 text-[10px] font-black uppercase tracking-widest text-slate-400">
              <Building2 size={12} />
              Personel Tipi
            </span>
            <select
              value={formData.employmentType || 'FIXED'}
              onChange={updateField('employmentType')}
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold outline-none transition-all focus:border-blue-500 focus:bg-white"
            >
              {Object.entries(EMPLOYMENT_TYPE_LABELS).map(([value, label]) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </select>
          </label>
        </div>

        <div className="mt-4">
          <PersonnelCompensationFields
            formData={formData}
            showEmploymentType={false}
            onChange={(field, value) => setFormData((current) => ({ ...current, [field]: value }))}
          />
        </div>

        {showNotes && (
          <label className="mt-4 block">
            <span className="mb-2 ml-1 flex items-center gap-1 text-[10px] font-black uppercase tracking-widest text-slate-400">
              <FileText size={12} />
              Notlar
            </span>
            <textarea
              rows="4"
              value={formData.notes || ''}
              onChange={updateField('notes')}
              className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-medium outline-none transition-all focus:border-blue-500 focus:bg-white"
              placeholder="Personel ile ilgili notlar..."
            />
          </label>
        )}
      </section>
    </div>
  );
};

export default PersonnelFormFields;

